import React,{useEffect,useState} from "react";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import Card from "olive-react-myoneui/lib/Card";
import NotificationItem from "./NotificationItem";
import axios  from'axios';
import moment from "moment";
import { useSelector,useDispatch } from "react-redux";
import BellNotificationItem from "./BellNotificationItem";
import { useTranslation } from "react-i18next";
import { commonModuleName } from "../../../constants/config";


function Notification({ className ,setNotification , notification}) {
  // const [notification, setNotification] = useState("false");
  const loggedInUser = useSelector((state) => state.user.user);
  const { t } = useTranslation(commonModuleName);
  useEffect(() => {
    const host = window.location.hostname
    console.log(loggedInUser.is_logged_in)
    let url
    if(loggedInUser.is_logged_in == "admin"){
      url = `https://${host}/admin/dashboard/notifications`
    }
    else{
      url=`https://${host}/dashboard/notifications`
    }
    axios.get(`${url}`, {
    })
    .then((response) => {
    setNotification(response.data.notifications)
    });
  }, []);

  // useEffect(() => {
  //   const host = window.location.hostname
  //   axios.get(`https://${host}/dashboard/notifications`, {
  //   })
  //   .then((response) => {
  //   setNotification(response.data.notifications)
  //   });
  // }, []);
  
 
  var localeData = moment.updateLocale('en', {
    relativeTime: {
        future: "in %s",
        past: "%s",
        s: 'Just now',
        ss: '%d seconds',
        m: "%d min ago",
        mm: "%d min ago",
        h: "%d hours ago",
        hh: "%d hours ago",
        d: "%d days ago",
        dd: "%d days ago",
        M: "%d months ago",
        MM: "%d months ago",
        y: "a year",
        yy: "%d years"
    }
  });

  const changeDate = (args) => {
    console.log(args,"date")
    
    if(args){
      var now = moment(new Date()); //todays date
      var end = moment(args); // another date
      var duration = moment.duration(now.diff(end));
      var days = duration.asDays();
      console.log(days)
      if(days > 1){
        const date = moment(args);
        return date.format('DD MMMM YYYY,h:mm A');
      }
      else{
        const date = moment.utc(args).local().startOf('seconds').fromNow()
        return date
      }
    }  
  }
  return (
    <Row>
      <Col lg={12}>
        <Card className={`${className || ""} py-1 px-0 border-0`}>
          <Card.Body className="p-0">
            {/* <NotificationItem className="mb-3" notificatonTitle="“James Lemire” Submitted Evidence" notificatonDesc="Submitted Evidence of Door Handle Manufaturing" time="Today, 01:40 pm"/>
            <NotificationItem className="mb-3" notificatonTitle="“James Lemire” Submitted Evidence" notificatonDesc="Submitted Evidence of Door Handle Manufaturing" time="Today, 01:40 pm"/>
            <NotificationItem className="mb-3" notificatonTitle="“James Lemire” Submitted Evidence" notificatonDesc="Submitted Evidence of Door Handle Manufaturing" time="Today, 01:40 pm"/>
            <NotificationItem className="mb-3" notificatonTitle="“James Lemire” Submitted Evidence" notificatonDesc="Submitted Evidence of Door Handle Manufaturing" time="Today, 01:40 pm" buttonTitle="Go to Course"/>
            <NotificationItem className="mb-3" notificatonTitle="“James Lemire” Submitted Evidence" notificatonDesc="Submitted Evidence of Door Handle Manufaturing" time="Today, 01:40 pm"/>
            <NotificationItem className="mb-3" notificatonTitle="“James Lemire” Submitted Evidence" notificatonDesc="Submitted Evidence of Door Handle Manufaturing" time="Today, 01:40 pm"/> */}
            {/* <BellNotificationItem className="mb-3" notificatonTitle="“James Lemire” Submitted Evidence" time="Just Now" /> */}
            {notification.length == 0 ? <h3 class="text-center no-notification"> {t("no_notification")}</h3> :  Object.keys(notification).map((key, index) => {
              let newdate = changeDate(notification[key].time)
              return (
                // <NotificationItem className="mb-3" notificatonTitle={notification[key].message} notificatonDesc={notification[key].message} time={newdate} notificationKey={key} notificatonUrl={notification[key].link}/>
                <BellNotificationItem className="mb-3" notificatonTitle={notification[key].message} time={newdate} notificationKey={key} notificatonUrl={notification[key].link} notificatonStatus={notification[key].seen}/>
              );
            }) }
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

export default Notification;
